<script setup>
    import { computed, ref } from "vue";
    import { useMailLogStore } from "../stores/maillog";
    import { storeToRefs } from "pinia";
    import FullView from "./full-view.vue";
    import { CircleCloseFilled } from "@element-plus/icons-vue"

    const store = useMailLogStore();
    const { mails, selectedItems, totalRows, currentPage, pageSize, isLoading } = storeToRefs(store);
    
    const openDrawer = ref(false);
    const currentMail = ref();
    const rawHtml = ref(false);

    const handleSelectionChange = (selected) => { 
        selectedItems.value = selected.map( (item) =>  item.id);     
    }

    const handleSizeChange = (val) => {
        pageSize.value = val;
        store.fetchLogs();
    }

    const handleCurrentChange = (val) => {
        currentPage.value = val;
        store.fetchLogs();
    }

    const cellClassName = ({ row, column, rowIndex, columnIndex }) => {
        return `wml-cell wml-${column.property}`;
    }

    const headerRowClassName = () => {
        return 'wml-header-row';
    }

    const openFullMail = (row, column, event) => {
        openDrawer.value = true;
        currentMail.value = row;
    }

    const total = computed(() => {
        return totalRows.value;
    }); 
</script>

<template>
    
    <el-table
        v-if="mails.length" 
        :data="mails" 
        style="width: 100%"
        :cell-class-name="cellClassName"
        :header-row-class-name="headerRowClassName"
        @selection-change="handleSelectionChange"
        @row-click="openFullMail"
        v-loading="isLoading"
        >
        <!-- <el-table-column type="expand">
            <template #default="props">Hello</template>
        </el-table-column>     -->
        <el-table-column type="selection" width="35" />
        <el-table-column prop="id" label="Id" width="65" />
        <el-table-column prop="to_email" label="To Email"/>
        <el-table-column prop="subject" label="Subject" />
        <el-table-column label="Message" >
            <template #default="scope">
                <el-text>{{ scope.row.message.substring(0,25) }}...</el-text>
            </template>
        </el-table-column>
        <el-table-column prop="headers" label="Headers" />
        <el-table-column prop="sent_date" label="Sent Date" />
    </el-table>
    
    <el-empty 
        v-if="!mails.length" 
        v-loading="isLoading"
        :image-size="200"
        description="No data found for the selected date range"    
    />
    
    <div class="wml-pagination" v-if="mails.length">
        <el-pagination
            :class="anand"
            layout="total, sizes, prev, pager, next" 
            :total="totalRows"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 30, 40, 50]" 
            :page-size="pageSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
    </div> 

    <el-dialog 
        v-model="openDrawer" 
        :with-header="true"
        :show-close="false"
        >
        <template #header="{ close, titleId, titleClass }">
                <div class="wml-mail-actions">
                    <div class="wml-input-group">
                        Raw html <el-switch v-model="rawHtml" />
                    </div>
                </div>
                
                <el-button type="danger" :round="false" @click="close">
                    <el-icon class="el-icon--left"><CircleCloseFilled /></el-icon>
                    Close
                </el-button>
            
        </template>
        <FullView :class="wml-full-mail" :currentMail="currentMail" :rawHtml="rawHtml" />
        
    </el-dialog>
    
</template>